import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const EditUser = () => {
  const [error, setError] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();
  const [roles, setRoles] = useState(['SUPERADMIN', 'USER', 'ANONYM']);
  const [showPassword, setShowPassword] = useState(false);

  const [user, setUser] = useState({
    username: '',
    password: '',
    observation: '',
    roles: '',
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`auth/basicinfo/${id}`);
        setUser(response.data);
      } catch (err) {
        setError("Erreur lors de la récupération des informations de l'utilisateur");
        console.error(err);
      }
    };

    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.put(`auth/edit/${id}`, user);

      if (res.data.error) {
        toast.error(res.data.error);
        return;
      }

      toast.success("Utilisateur modifié avec succès");

      navigate('/listusers');

    } catch (err) {
      toast.error(
        err.response?.data?.error ||
        "Erreur lors de la modification de l'utilisateur"
      );
    }
  };

  /*   const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        await axios.put(`auth/edit/${id}`, user).then((res) => {
          //console.log(res.data);
        });
  
        navigate('/users'); // Redirige vers la liste des utilisateurs après la modification
      } catch (err) {
        setError("Erreur lors de la modification de l'utilisateur");
        console.error(err);
      }
    }; */

  return (
    <div class="container pt-5 mt-5  ">
      <div class="row">
        <div class="col-md-6 mx-auto bg-info p-5 rounded-lg  ">
          <h1>Modifier l'Utilisateur</h1>
          <div className="row">
            <div className="col p-2 bg-danger mb-4">{error && <p>{error}</p>}</div>
          </div>
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="username">Username</label>
              <input type="text" id="username" name="username" value={user.username} onChange={handleChange} required className="form-control" />
            </div>
            <div>
              <label htmlFor="observation">Observation</label>
              <input type="text" id="observation" name="observation" value={user.observation} onChange={handleChange} required className="form-control" />
            </div>
            <div>
              <label htmlFor="password">Password</label>
              <div style={{ position: 'relative' }}>
                <input type={showPassword ? 'text' : 'password'} id="password" name="password" value={user.password} onChange={handleChange} required className="form-control" />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  <i className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'}></i>
                </button>
              </div>
            </div>
            <div>
              <label htmlFor="roles">Roles</label>
              <select id="roles" name="roles" value={user.roles} onChange={handleChange} required className="form-control ">
                {roles.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </div>
            <button type="submit" className="btn btn-success mt-5">
              Enregistrer la modification
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
